import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
import { useMemo as r } from "react";
import { canonicalZoom as i, snapBbox as a } from "@maat/utils";
//#region src/properties/useMapPriceDistributionQuery.ts
var o = (o, s = !0) => {
	let c = r(() => {
		if (!o) return;
		let { minPrice: e, maxPrice: t, ...n } = o;
		return {
			...n,
			zoom: i(o.zoom),
			bbox: a(o.bbox, o.zoom)
		};
	}, [o]);
	return t({
		queryKey: e.mapPriceDistribution(c),
		queryFn: () => n.getMapPriceDistribution(c),
		enabled: s && !!c?.bbox,
		placeholderData: (e) => e
	});
};
//#endregion
export { o as useMapPriceDistributionQuery };
